// extracted by mini-css-extract-plugin
export default {"pay-box":"pay-box--7ekA","pay-button":"pay-button--GEkN","full-screen":"full-screen--gWEq","pay-info":"pay-info--I2Ym","has-discount":"has-discount--Sf7I"};